<ng-template>
    <app-change-password-modal [typeNumber]="'2'"></app-change-password-modal>
</ng-template>
<!-- <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div> -->